<prod-menu
  *ngIf="type === 'Products'"
  [title]="title"
  [products]="menuContent.children"
  [specialMenuTitle]="menuContent['special-menu-title']"
  [specialMenuPath]="menuContent['special-menu-path']" (closeMenuEvent)="closeNavEventHandler()">
</prod-menu>

<solution-menu *ngIf="type === 'Solutions'" [title]="title" [products]="menuContent.children" (closeMenuEvent)="closeNavEventHandler()"></solution-menu>

<resource-menu *ngIf="type === 'Resource'" [title]="title" [resources]="menuContent.children" (closeMenuEvent)="closeNavEventHandler()"></resource-menu>
